<pdq-tabs-group variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
  @for (tab of tabs; track tab.value) {
    <pdq-tab
      [label]="tab.label"
      [value]="tab.value"
      [active]="tab.value === activeTab"
      [disabled]="tab.disabled"
      [locked]="tab.locked"></pdq-tab>
  }
</pdq-tabs-group>

<div class="cart-control-form-container">
  @switch (activeTab) {
    @case (CartControlFormTab.SETTINGS) {
      <cart-control-form-settings [formGroup]="formGroup"></cart-control-form-settings>
    }
    @case (CartControlFormTab.CONFIGURATIONS) {
      <cart-control-form-configurations
        [formGroup]="formGroup"
        [shopCurrencySymbol]="shopCurrencySymbol"></cart-control-form-configurations>
    }
    @case (CartControlFormTab.DISPLAY_CONDITIONS) {
      <cart-control-form-display-conditions
        [formGroup]="formGroup"
        [displayRules]="displayRules"
        [displayRulesEntities]="displayRulesEntities"
        [shopCurrencySymbol]="shopCurrencySymbol"></cart-control-form-display-conditions>
    }
    @case (CartControlFormTab.INSTALLATION) {
      <cart-control-form-installation [formGroup]="formGroup"></cart-control-form-installation>
    }
  }
</div>
